import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import { getAspectRatioForImages } from '@/utils/aspectRatioUtils';

import { Heading } from '@/components/Cms/Heading/Heading';
import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type {
  ContentfulHeadingFragment,
  ContentfulImageWithFocalPointFragment,
} from '@/graphql/contentful/api';
import { useDeviceDetect } from '@/hooks/useDeviceDetect';
import { theme } from '@/theme';

import type { CardProps } from '../../types';
import { CardCTA } from '../CardCTA/CardCTA';

import * as S from './SquadCardType.styles';
export const SquadCardType = (props: CardProps) => {
  const {
    aspectRatio,
    backgroundAlignment,
    backgroundColor,
    cardText,
    className,
    media,
    mediaAnimationEffect,
    mediaWrapperType,
    placeholderHeading,
    preload,
    textAlignment,
    textColor,
    type,
  } = props;
  const hasMedia = !!(
    media?.image?.url ??
    media?.imageMobile?.url ??
    media?.video?.url ??
    media?.videoMobile?.url
  );
  const { deviceType } = useDeviceDetect();

  return (
    <S.Wrapper
      $type={type}
      $visibleInDesktop={props.visibleInDesktop}
      $visibleInMobile={props.visibleInMobile}
      backgroundColor={backgroundColor?.value ?? theme.colors.transparent}
      className={className}
      data-testid='SquadCardTypeWrapper'
    >
      {hasMedia && (
        <S.MediaWrapper
          className={`${type}Wrapper`}
          mediaAnimationEffect={
            mediaAnimationEffect === 'zoomOnHover' ? 'zoomOnHover' : null
          }
        >
          <S.Media
            $aspectRatio={getAspectRatioForImages(
              mediaWrapperType,
              null,
              null,
              null,
              deviceType,
            )}
            $backgroundAlignment={backgroundAlignment}
          >
            <MediaWrapper
              {...(media as ContentfulImageWithFocalPointFragment)}
              aspectRatio={aspectRatio}
              data-test-id='BaseCardTypeBackgroundImage'
              mediaWrapperType={mediaWrapperType}
              preload={preload}
              sizes='(max-width: 600px) 50vw, 20vw'
            />
          </S.Media>
        </S.MediaWrapper>
      )}

      {placeholderHeading && (
        <Heading
          Heading={placeholderHeading as ContentfulHeadingFragment}
          data-testid='SquadCardTypeHeading'
        />
      )}
      {cardText && (
        <S.Text
          color={textColor ?? theme.colors.default}
          dangerouslySetInnerHTML={{
            __html: documentToHtmlString(cardText.json),
          }}
          data-testid='SquadCardTypeText'
          textAlign={textAlignment ?? 'left'}
        />
      )}
      <CardCTA {...props}></CardCTA>
    </S.Wrapper>
  );
};
